import { ICON_CS } from '@repo/assets';
import { Input } from '@repo/components';
import { PASSPORT } from '@repo/constants';
import { Button, Icon } from '@successmode-ktp/kui';
import { useState } from 'react';
import styled from 'styled-components';

type Props = {
  onBackPage: () => void;
  onSubmit: (passportNumber: string) => void;
  lang: 'KOR' | 'ENG';
};

export const Passport = ({ onBackPage, onSubmit, lang }: Props) => {
  const [passportNumber, setPassportNumber] = useState('');

  const toUpperCase = (value: string) => {
    setPassportNumber(value.toUpperCase().replace(/\s+/g, ''));
  };

  return (
    <>
      <TitleWrapper>
        <button type='button' onClick={onBackPage}>
          <Icon.ChevronLeft fillColor='#A7A7A7' />
        </button>
        <Title>
          <IconCs src={ICON_CS} alt='' />
          {PASSPORT[lang].title}
        </Title>
        <Box />
      </TitleWrapper>
      <SubTitle>{PASSPORT[lang].contents}</SubTitle>
      <InputWrapper>
        <Input
          label={PASSPORT[lang].label}
          placeholder={PASSPORT[lang].placeholder}
          isRequired
          onChange={(e) => toUpperCase(e.target.value)}
          value={passportNumber}
        />
      </InputWrapper>
      <ButtonWrapper>
        <Button
          type='button'
          disabled={!passportNumber}
          onClick={() => onSubmit(passportNumber)}
        >
          {PASSPORT[lang].btnText}
        </Button>
      </ButtonWrapper>
    </>
  );
};

const TitleWrapper = styled.h6`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px 20px;
  width: 100%;
  background-color: #fff;
  border-bottom: 1px solid #f4f4f4;
`;

const Box = styled.div`
  width: 24px;
  height: 24px;
`;

const Title = styled.span`
  display: flex;
  align-items: center;
  gap: 8px;
  color: #030303;
  font-size: 20px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.4px;
`;

const IconCs = styled.img`
  display: block;
  width: 24px;
  height: 24px;
`;

const SubTitle = styled.strong`
  display: block;
  padding: 16px 20px 24px;
  color: #3a3b3e;
  font-size: 24px;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.6px;
  text-align: left;
  width: 100%;
`;

const InputWrapper = styled.div`
  padding: 0 20px;
  width: 100%;
`;

const ButtonWrapper = styled.div`
  padding: 20px 20px 40px;
  width: 100%;
  position: fixed;
  bottom: 0;
  background: #fff;
  box-shadow: 0px -3px 6px 0px rgba(203, 203, 203, 0.25);
`;
